import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaFontSize } from 'yoda-ui/yodaTheme';

export const chartWrapper: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
};

export const chartTitle: SxProps<Theme> = {
  textAlign: 'left',
  fontSize: YodaFontSize.xLarge,
  fontWeight: 700,
  marginBottom: '24px',
};

export const loaderWrapper: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
